import {
  constants,
  mediaQueryStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs, sm, md } = breakpoints.BreakpointNames;
const { ui } = constants.colors;
const greyDark = ui.neutral[700];

export const contentVeilContainer = {
  [mediaQuery.between(sm, md)]: {
    width: "515px",
  },
};

export const rootCss = {
  borderRadius: "8px",
  height: "16px",
  marginTop: "16px",

  ":nth-of-type(2)": {
    width: "275px",
  },
  ":nth-of-type(3)": {
    width: "285px",
  },
  ":nth-of-type(4)": {
    width: "280px",
  },
  ":nth-of-type(5)": {
    width: "277px",
  },

  [mediaQuery.between(xs, sm)]: {
    width: "400px",
    ":nth-of-type(2)": {
      width: "380px",
    },
    ":nth-of-type(3)": {
      width: "385px",
    },
    ":nth-of-type(4)": {
      width: "380px",
    },
    ":nth-of-type(5)": {
      width: "377px",
    },
  },

  [mediaQuery.between(sm, md)]: {
    width: "620px",
    ":nth-of-type(2)": {
      width: "588px",
    },
    ":nth-of-type(3)": {
      width: "620px",
    },
    ":nth-of-type(4)": {
      width: "604px",
    },
    ":nth-of-type(5)": {
      width: "588px",
    },
  },

  [mediaQuery.downTo(md)]: {
    width: "720px",
    ":nth-of-type(2)": {
      width: "688px",
    },
    ":nth-of-type(3)": {
      width: "720px",
    },
    ":nth-of-type(4)": {
      width: "704px",
    },
    ":nth-of-type(5)": {
      width: "688px",
    },
  },
};

export const shimmerCss = {
  background: greyDark,
  opacity: "15%",
};

export const visuallyHiddenTextCss = {
  ...visuallyHiddenStyles,
};
